import { MANAGER_MAINTENANCE_DATA } from '../Constant/ActionConstant';

export const setManagerMaintenanceData = (data) => ({
    type: MANAGER_MAINTENANCE_DATA,
    payload: data
});
